var map = {
	"./anders": 68,
	"./anders.jpg": 68,
	"./arrow": 69,
	"./arrow.svg": 69,
	"./avatar-1": 70,
	"./avatar-1.jpg": 70,
	"./avatar-2": 71,
	"./avatar-2.jpg": 71,
	"./avatar-3": 72,
	"./avatar-3.jpg": 72,
	"./bottle": 73,
	"./bottle-pattern": 74,
	"./bottle-pattern.svg": 74,
	"./bottle.svg": 73,
	"./bottles-outline": 75,
	"./bottles-outline.svg": 75,
	"./close": 76,
	"./close-alt": 77,
	"./close-alt.svg": 77,
	"./close.svg": 76,
	"./fine-wine-bottle": 78,
	"./fine-wine-bottle.webp": 78,
	"./fine-wines": 79,
	"./fine-wines.webp": 79,
	"./frontend/about_first": 80,
	"./frontend/about_first.webp": 80,
	"./frontend/about_second": 81,
	"./frontend/about_second.webp": 81,
	"./frontend/arrow_down": 82,
	"./frontend/arrow_down.svg": 82,
	"./frontend/blue": 83,
	"./frontend/blue.png": 83,
	"./frontend/clock": 84,
	"./frontend/clock.svg": 84,
	"./frontend/close": 85,
	"./frontend/close.svg": 85,
	"./frontend/edit": 86,
	"./frontend/edit.svg": 86,
	"./frontend/facebook": 52,
	"./frontend/facebook.png": 52,
	"./frontend/facebook.svg": 128,
	"./frontend/greater": 87,
	"./frontend/greater.svg": 87,
	"./frontend/instagram": 53,
	"./frontend/instagram.png": 53,
	"./frontend/instagram.svg": 129,
	"./frontend/less": 88,
	"./frontend/less.svg": 88,
	"./frontend/linkedin": 54,
	"./frontend/linkedin.png": 54,
	"./frontend/linkedin.svg": 130,
	"./frontend/logo": 89,
	"./frontend/logo.svg": 89,
	"./frontend/map": 90,
	"./frontend/map.svg": 90,
	"./frontend/menu": 91,
	"./frontend/menu.svg": 91,
	"./frontend/min": 92,
	"./frontend/min.svg": 92,
	"./frontend/phone": 93,
	"./frontend/phone.svg": 93,
	"./frontend/plus": 94,
	"./frontend/plus.svg": 94,
	"./frontend/question_down": 95,
	"./frontend/question_down.svg": 95,
	"./frontend/search": 96,
	"./frontend/search.svg": 96,
	"./frontend/slide": 97,
	"./frontend/slide.webp": 97,
	"./frontend/today": 98,
	"./frontend/today.png": 98,
	"./frontend/twitter": 55,
	"./frontend/twitter.png": 55,
	"./frontend/twitter.svg": 131,
	"./frontend/yellow": 99,
	"./frontend/yellow.png": 99,
	"./h-bottle": 100,
	"./h-bottle.svg": 100,
	"./jero-iphone": 101,
	"./jero-iphone.webp": 101,
	"./jero-macbook": 102,
	"./jero-macbook.webp": 102,
	"./jeroboam": 103,
	"./jeroboam-narrow": 104,
	"./jeroboam-narrow.svg": 104,
	"./jeroboam.svg": 103,
	"./logo": 105,
	"./logo-payoff": 106,
	"./logo-payoff.svg": 106,
	"./logo-simple": 107,
	"./logo-simple.svg": 107,
	"./logo.svg": 105,
	"./magnus": 108,
	"./magnus.jpg": 108,
	"./market": 109,
	"./market-narrow": 110,
	"./market-narrow.svg": 110,
	"./market.svg": 109,
	"./martin": 111,
	"./martin.jpg": 111,
	"./nav": 112,
	"./nav.svg": 112,
	"./tuscany": 113,
	"./tuscany.svg": 113,
	"./user_auth_bg": 114,
	"./user_auth_bg.svg": 114,
	"./wine-curve": 115,
	"./wine-curve.webp": 115,
	"./wine-icon": 116,
	"./wine-icon.svg": 116
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 127;